import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'tasks',
    component: Children,

    children: [
      {
        path: '',
        name: 'tasks',
        component: () => import('../pages/TasksPage.vue')
      }
    ]
  }
];

export default routes;
